import FacetsCounterCalculator from 'components/algolia/facets_counter_calculator'
import { loadTemplate } from 'utils/load_template'
import { showElement, hideElement } from 'utils/toggle_element_visibility'

class DistinctRefinementWidget {
  constructor(params = {}) {
    this.defaultClasses = {
      list: "ais-RefinementList",
      item: "ais-RefinementList-item"
    }
    this.buildWidget(params)
  }

  buildWidget(params) {
    const customRenderFn = (renderOptions, isFirstRendering) => {
      const container = document.getElementById(renderOptions.widgetParams.container)

      if (!isFirstRendering) {
        if (params.showCounters) {
          FacetsCounterCalculator.loadItemsWithCounters(params.facetCounterAttribute, renderOptions, container, this.loadItems.bind(this), params.facetCounterComparisonFn)
        } else {
          const { items, refine, widgetParams, searchForItems } = renderOptions
          this.loadItems(items, refine, widgetParams, container, searchForItems)
        }
      }
    }

    this.mainWidget = params.connector(customRenderFn)
  }

  loadItems(items, refine, widgetParams, container, searchForItems) {
    const listElement = this.createListElement(widgetParams)
    this.createListItemElements(listElement, items, widgetParams)

    this.createSearchBoxElement(container, widgetParams)

    // I remove them and add them back because I have to keep the rest of the container for the search box
    Array.from(container.getElementsByClassName(this.defaultClasses.list)).forEach((el) => { el.remove() })
    container.appendChild(listElement)

    this.bindEvents(refine, items, container, widgetParams, searchForItems)
  }

  createSearchBoxElement(container, widgetParams) {
    const id = `${widgetParams.attribute}_search_box`

    if (widgetParams.searchable && document.getElementById(id) === null) {
      container.innerHTML = loadTemplate("cle_filters_search_box").interpolateObject({ id: id, placeholder: widgetParams.searchablePlaceholder || "Type a name" })
    }
  }

  createListElement(widgetParams) {
    const listElement = document.createElement("ul")
    listElement.classList.add(this.defaultClasses.list) // Preserves the same classes as the original RefinementList widget

    if (widgetParams.cssClasses)
      listElement.classList.add(widgetParams.cssClasses.root)

    return listElement
  }

  createListItemElements(listElement, items, widgetParams) {
    items.forEach((item) => {
      // Templates can come as functions or as strings
      const templateString = typeof(widgetParams.templates.item) === "function" ? widgetParams.templates.item(item) : widgetParams.templates.item
      const liElement = document.createElement("li")
      liElement.classList.add(this.defaultClasses.item)
      liElement.innerHTML = templateString.interpolateObject({ ...item, checked: item.isRefined ? "checked" : "" })
      listElement.appendChild(liElement)
    })
  }

  bindEvents(refine, items, container, widgetParams, searchForItems) {
    items.forEach((item) => {
      const el = container.querySelector(`input[type="checkbox"][value="${item.value}"], input[type="radio"][value="${item.value}"]`)

      if (el) { // Item could have been removed if count is 0
        el.addEventListener("change", (evt) => {
          refine(el.value)

          // Reset form if any filter value is selected
          if (widgetParams.searchable) {
            container.querySelector(".searchItemsForm").reset()
          }
        })
      }
    })

    if (widgetParams.searchable) {
      this.bindSearchBoxEvents(container, searchForItems)
    }
  }

  bindSearchBoxEvents(container, searchForItems) {
    ["change", "keydown", "paste", "cut"].forEach((event) => {
      container.querySelector(".searchItemsInput").addEventListener(event, (evt) => {
        const previousValue = evt.target.value

        setTimeout(function() {
          const resetBtn = container.querySelector(".resetIcon")

          if (evt.target.value.length > 0) {
            showElement(resetBtn)
          } else {
            hideElement(resetBtn)
          }

          if (previousValue !== evt.target.value) {
            searchForItems(evt.target.value)
          }
        }, 200)
      })
    })
  }

  get widget(){
    return this.mainWidget
  }

  set widget(widget) {
    this.mainWidget = widget
  }
}

export default DistinctRefinementWidget
